import { inject, Injectable, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ListenTokenService {
  private readonly tokenSignal = signal<string | null>(null);
  private readonly route = inject(ActivatedRoute);

  constructor() {
    this.listenForToken();
  }

  private listenForToken(): void {
    this.route.queryParamMap.pipe(take(1)).subscribe((params) => {
      const token = params.get('token');
      if (token) {
        this.tokenSignal.set(token);
      }
    });
  }

  get token(): string | null {
    return this.tokenSignal();
  }
}
